import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SnackBarConfig } from "../snackbar";
import { nameValidator } from "../name-validator.directive";
import { emailValidator } from "../email-validator.directive";
import { noSpacesValidator } from "../space-validator.directive";
import { MatButtonModule } from "@angular/material/button";
import { ServicesService } from "../services/services.service";

@Component({
  selector: 'app-contact-us',
  standalone: true,
  imports: [CommonModule,ReactiveFormsModule,MatButtonModule],
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss'
})
export class ContactUsComponent {

  public contactForm!: FormGroup;
  public isLogin!: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private emailService: ServicesService,
    private snackBar: MatSnackBar
  ){}

  ngOnInit() {
    this.contactForm = this.formBuilder.group({
        name: ["", [Validators.required, nameValidator(), noSpacesValidator()]],
        email: ["", [Validators.required, emailValidator()]],
        subject: ["", [Validators.required, noSpacesValidator()]],
        message: ["", [Validators.required, noSpacesValidator()]],
    });
}

public isInvalid(controlName: string, validatorName?: string): boolean {
    const contorl = this.contactForm.get(controlName);
    if (validatorName) {
        return contorl!.errors?.[validatorName];
    }
    return contorl!.invalid && contorl!.touched;
}

private openSnackBar(message: string, action: string): void {
    this.snackBar.open(message, action, {
        ...SnackBarConfig.Defaults,
    });
}

private trimSpaces(): void {
    const controlNames = ["name", "subject", "message"];
    controlNames.forEach((controlName) => {
        const control = this.contactForm.get(controlName);
        if (control && control.value) {
            control.setValue(control.value.trim());
        }
    });
}

public onSubmit(): void {
    this.trimSpaces();
    const emailData = {
        contactBody: this.contactForm.value
      };
    this.emailService.sendContactEmail(emailData).subscribe({
        next: (response) => {
            this.openSnackBar(response, SnackBarConfig.Actions.OKAY);
        },
        error: (error) => {},
    });
    this.contactForm.reset();
}

}
